
const CACHE_RELOAD_QUERY = 'cache_reload=1'

enum CACHE_KEYS {
  TRANSLATIONS = 'translations',
  CALENDAR_FILTER_OPTIONS = 'calendarFilterOptions',
  CATEGORY_START = 'categoryStart',
  CATEGORY = 'category-',
  REGION = 'region-',
  CAMPAIGNS_PROMOTED = 'promotedCampaigns',
  CAMPAIGNS_ALL = 'allCampaigns',
  FOOTER = 'footer',
  SIDEBAR = 'sidebar',
  NEWSLETTER_LISTS = 'newsletterLists',
  ALERT = 'alert',
  DESTINATION_LIST_WITH_CATEGORIES = 'destinationListWithCategories',
  CHARTER_PACKAGES_FILTER_OPTIONS = 'charterPackagesFilterOptions',
  HOTEL_LIST = 'hotelList-',
  CHARTER_HOTEL = 'charterHotel-',
  ROLFS_HOTEL = 'rolfsHotel-',
  ROLFS_HOTEL_DESCRIPTION = 'rolfsHotelDescription-',
  TOURLEADER_LIST = 'tourleaderList',
  TOURLEADER = 'tourleader-',
  BLOG_LIST = 'blogList',
  BLOG = 'blog-',
  STATIC_PAGE = 'staticPage-',
}

export {
  CACHE_KEYS,
  CACHE_RELOAD_QUERY,
}